import { toAbsoluteMinutes } from "./dateHelpers";

// Where a Week view block lands when it's dropped. `gridMins` is the snapped drop
// point in grid minutes (0 = the top of the grid, which is "day starts at", not
// always midnight). The block keeps its length and is stopped at the bottom of
// the grid instead of being squashed (dropping a 1-hour event at the end of the
// day used to save it as 23:59-23:59). Shared by the mouse and touch drops so
// they can't disagree; the mouse drop used to skip the "day starts at" shift.
const hhmm = (m) => {
  const v = Math.max(0, Math.min(1439, m));
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
};
const toMin = (t) => {
  const [h, m] = String(t || "00:00").split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};

// A block's length in minutes (no end time = one hour).
export function blockMinutes(item) {
  const origStart = toMin(item?.time);
  const origEnd = item?.endTime ? toMin(item.endTime) : origStart + 60;
  return origEnd > origStart ? origEnd - origStart : 60;
}

// The latest grid start that still fits the whole block inside the day. Used
// while dragging too, so the ghost block can't hang past the bottom row: it used
// to, which made the grid taller, which let the edge scrolling run on into empty
// space below 11 PM (Jade, 2026-10-20).
export function clampGridStart(gridMins, item) {
  return Math.max(0, Math.min(gridMins, 1440 - blockMinutes(item)));
}

export function weekDropTimes(gridMins, item, dayStartHour = 0) {
  const dur = blockMinutes(item);
  const gridStart = clampGridStart(gridMins, item);
  const start = toAbsoluteMinutes(gridStart, dayStartHour);
  return { time: hhmm(start), endTime: hhmm(start + dur) };
}
